import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M19 8H5a1 1 0 0 1 0-2h14a1 1 0 1 1 0 2m-2 5H7a1 1 0 1 1 0-2h10a1 1 0 1 1 0 2m-2 5H9a1 1 0 1 1 0-2h6a1 1 0 1 1 0 2"
    }
  )
);
var SvgFilterFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FilterFilled_default = SvgFilterFilled;

export { FilterFilled_default as default };
